import React, { useEffect, useState } from 'react'
import Marquee from 'react-fast-marquee'
import './style.css'

const LandingPage = () => {
  const [Image, setImages] = useState([])
  useEffect(() => {
    fetch('/PackageJson/FooterImages/FooterImages.json')
      .then(response => response.json())
      .then(data => {
        setImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  const onClickLinkOpen = item => {
    // window.open(item.link, '_blank')
  }
  const sortedData = Image.sort((b, a) => b.displayOrder - a.displayOrder)
  return (
    <div
      style={{
        padding: '0px 0'
      }}
      className='Testimonial_min'
    >
      <Marquee speed={100} className='mt-5' pauseOnHover autoFill={true}>
        {sortedData.map((item, index) => (
          <div
            key={index}
            className='marque_container'
            onClick={() => onClickLinkOpen(item)}
          >
            <div>
              <img
                src={item.ImagesPath}
                style={{ width: '100%' }}
                alt={`Carousel ${index}`}
                className='carousel-image'
              />
              <p>{item.title}</p>
            </div>
          </div>
        ))}
      </Marquee>
    </div>
  )
}

export default LandingPage
